/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-notification-off': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M3.125 14.375v-1l1.688-1.688A.569.569 0 005 11.25V8.125a5 5 0 018.125-3.9l.9-.894a6.119 6.119 0 00-3.4-1.456V.625h-1.25v1.25a6.344 6.344 0 00-5.625 6.25V11l-1.688 1.688a.569.569 0 00-.187.437v1.25h1.25zM16.25 11V8.125a6.25 6.25 0 00-.681-2.813l3.181-3.18-.881-.882L1.25 17.869l.881.881 3.125-3.125h1.619a3.125 3.125 0 006.25 0H17.5a.587.587 0 00.625-.625v-1.875a.569.569 0 00-.188-.438L16.25 11zM10 17.5a1.875 1.875 0 01-1.875-1.875h3.75c0 1.036-.84 1.875-1.875 1.875zm6.875-3.125H6.512l8.125-8.125c.24.596.363 1.233.363 1.875v3.125a.569.569 0 00.188.438l1.687 1.687v1z"/>'
  }
})
